//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'post',
      required: true,
    },
    limit: {
      type: Number,
      default: 5,
    },
    link: {
      type: String,
      default: '/',
    },
  },

  computed: {
    classes() {
      return {
        ['collection--forum-' + this.type]: this.type,
        'collection--list': this.type !== 'group',
      }
    },

    linkLabel() {
      return (
        this.$translation('button.showAll.' + this.type) ??
        this.$translation('button.learnMore.standard')
      )
    },

    listItems() {
      let items
      if (this.type === 'post' && this.items?.length === 0) {
        items = [
          {
            title: this.$translation('profile.noPosts'),
            url: process.env.FORUM_URL ?? '',
          },
        ]
      } else {
        items = this.items.slice(0, this.limit)
      }

      return items
    },
  },
}
